import axios from "axios";
import { baseUrl } from "../config/env";

const config = {
  headers: {
    accesstoken: localStorage.getItem("accesstoken"),
  },
};

export function getHome() {
  return axios.get(baseUrl + "/");
}
export function createFacebookLogin(data) {
  return axios.post(baseUrl + "/auth/facebook", data);
}
export function createRegister(data) {
  return axios.post(baseUrl + "/accounts/join", data);
}

export function fetchUserDetails() {
  return axios.get(baseUrl + `/accounts/profile`, config);
}
export function uploadFile(data) {
  return axios.post(baseUrl + `/file/upload`, data, config);
}
export function createRecordFile(data) {
  return axios.post(baseUrl + `/audio/record/register`, data, config);
}
export function deleteFile(id, path) {
  return axios.get(baseUrl + `/file/delete/${id}?path=${path}`, config);
}
export function fetchFileList(params) {
  window.console.log("params", params);
  return axios.get(baseUrl + `/audio/fileList`, config);
}

export function createCheckout(data) {
  return axios.post(baseUrl + `/checkout/payments/register`, data, config);
}

export function deleteCheckout(id) {
  return axios.get(baseUrl + `/checkout/payments/delete/${id}`, config);
}
export function getCheckoutComplete(params) {
  return axios.get(
    baseUrl + `/checkout/complete?imp_uid=${params.imp_uid}`,
    config
  );
}

export function createNoiseCancel(data) {
  return axios.post(baseUrl + `/file/noisecancel`, data, config);
}

export function createEncoding(data) {
  return axios.post(baseUrl + `/file/encoding`, data, config);
}

export function fetchProgress() {
  return axios.get(baseUrl + `/file/progress`, config);
}
